import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';

const DeleteInternalUserForm = props => {
  const { deleteModal, deletingUser } = props;

  return (
    <>
      <Dimmer active={deletingUser}>
        <Loader size="massive">Deleting</Loader>
      </Dimmer>
      <SemanticToastContainer />
      <p>Are you sure you want to delete {deleteModal.selectedUser.email}?</p>
    </>
  );
};

const mapStateToProps = ({ access }) => ({
  deleteModal: access.deleteModal,
  deletingUser: access.deletingUser,
});

DeleteInternalUserForm.propTypes = {
  deleteModal: PropTypes.object.isRequired,
  deletingUser: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(DeleteInternalUserForm);
